import type { ThreadRow } from './api.ts';

function formatRef(ref: string): string {
  const n = ref.trim().toUpperCase().replace(/[^0-9A-Z]/g, '');
  if (n.length === 6) return `${n.slice(0, 3)}-${n.slice(3)}`;
  return ref;
}

export function threadTitle(thread: ThreadRow): string {
  const question = thread.subject?.trim();
  if (question) {
    return question.replace(/\s+/g, ' ');
  }

  if (thread.ref) return `空音 ${formatRef(thread.ref)}`;
  return `空音 ${thread.id.slice(0, 8)}`;
}
